import React from "react";
import { Button, CircularProgress, IconButton } from "@mui/material";
import { RWebShare } from "react-web-share";
import ImageLoader from "../../components/imageLoader";
import { apiCall } from "../../utils/helpers";
import STAR from "../../assets/images/wishlist-star.svg";
import BUSINESSCARD from "../../assets/images/Business.png";
import DOPELOGO from "../../assets/images/dopelogo.svg";
import FB from "../../assets/images/fb.svg";
import INSTA from "../../assets/images/insta.svg";
import TWITTER from "../../assets/images/twitter.svg";
import LINKEDIN from "../../assets/images/linkedin.svg";

export default function WaitlistView({ data = {}, setWaitlistScreen = {} }) {
  const ismobile = window.innerWidth <= 768;
  const [loading, setLoading] = React.useState(false);
  const [waitlistCount, setWaitListCount] = React.useState(0);
  const [waitlistData, setWaitlistData] = React.useState({});

  const getWishlistCount = () => {
    setLoading(true);
    apiCall
      .post("v1/dopamine/getWaitlistCount", {
        api_name: "getWaitlistCount",
        user_id: data?.user_id,
        key: "JWT",
        secret: "DOPAMINE",
      })
      .then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data.success) {
          const waitlist_count = res.data.data.waitlist_count;
          setWaitListCount(waitlist_count);
          setWaitlistData(res?.data?.data);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const socialIcons = [
    {
      icon: FB,
      link: `https://www.facebook.com/sharer/sharer.php?u=https%3A//dopamine.fit/?source=facebook%26medium=web%26user=${data?.user_id}`,
    },
    {
      icon: INSTA,
      link: "#",
    },
    {
      icon: TWITTER,
      link: `https://twitter.com/intent/tweet?text=https%3A//dopamine.fit/?source=twitter%26medium=web%26user=${data?.user_id}`,
    },
    {
      icon: LINKEDIN,
      link: `https://www.linkedin.com/shareArticle?mini=true&url=https%3A//dopamine.fit/?source=linkedin%26medium=web%26user=${data?.user_id}`,
    },
  ];

  React.useEffect(() => {
    getWishlistCount();
    setWaitlistScreen(true);
  }, []);
  return (
    <>
      {loading ? (
        <div style={{ margin: "auto", textAlign: "center" }}>
          <CircularProgress />
        </div>
      ) : waitlistData?.admin_type_id === 1 ? (
        <>
          <div
            className="waitlist-top-section"
            style={{ maxHeight: ismobile ? "200px" : "230px" }}
          >
            {
              // waitlistData?.admin_type_id === 1 &&
              <>
                <p className="waitlist-top-section-para">
                  <ImageLoader
                    src={STAR}
                    style={{ objectFit: "contain", width: 14 }}
                  />
                  <span style={{ margin: "0 6px" }}>
                    {/* Exclusive NFC Business card for experts */}
                    Your Exclusive Business card
                  </span>
                  <ImageLoader
                    src={STAR}
                    style={{ objectFit: "contain", width: 14 }}
                  />
                </p>
                <div className="card-div">
                  <ImageLoader
                    src={
                      BUSINESSCARD
                      // waitlistData?.admin_type_id === 1
                      //   ? BUSINESSCARD
                      //   : waitlistData?.admin_type_id === 2
                      //   ? BUSINESSCARDBRAND
                      //   : BUSINESSCARDCENTRE
                    }
                    style={{
                      objectFit: "contain",
                      width: "80%",
                      height: "80%",
                      marginBottom: ismobile ? "-70px" : "-10px",

                      // // marginTop: "10%",
                      // height: "227px",
                    }}
                  />
                  <p
                    className="name"
                    style={{
                      textAlign: "right",
                      right: "16%",
                      top: ismobile ? "105%" : "70%",
                      color: "rgba(255, 255, 255, 0.67)",
                    }}
                  >
                    {data?.name}
                  </p>
                </div>
              </>
            }
            {/* {waitlistData?.admin_type_id !== 1 && (
              <div className="polygon-div">
                <ImageLoader
                  src={CLOCK}
                  style={{
                    objectFit: "contain",
                    width: 100,
                    height: "auto",
                    margin: ismobile ? "40px 0 20px 0" : "50px 0 50px 0",
                  }}
                />
                <div style={{ textAlign: "center" }} className="text-div">
                  <p className="white-line">You’re on the waitlist</p>
                  <p className="queue-number">
                    {waitlistCount === 0 ? "--" : waitlistCount}
                  </p>
                  <p className="grey-line">Your position in queue</p>
                </div>
              </div>
            )} */}
          </div>

          <div
            style={{
              padding: ismobile ? "34px 25px 45px 25px" : "0px 25px 45px 25px",
            }}
          >
            <div
              style={{
                padding: "1px",
                background:
                  "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                borderRadius: "11.6279px",
              }}
            >
              <div
                className="waitlist-bottom-section"
                style={{
                  borderRadius: "11.6279px",

                  // paddingTop: data?.admin_type_id !== 1 && ismobile ? 160 : null,
                }}
              >
                {(waitlistData?.admin_type_id === 1 ||
                  waitlistData?.admin_type_id === 2 ||
                  waitlistData?.admin_type_id === 3) && (
                  <div style={{ textAlign: "center", marginTop: 20 }}>
                    <p className="white-line">You’re on the waitlist</p>
                    <p className="queue-number">
                      {waitlistCount === 0 ? "--" : waitlistCount}
                    </p>
                    <p className="grey-line">Your position in queue</p>
                  </div>
                )}
                <div className="early-access-div">
                  <div className="text-div">
                    <p className="white-line">Want to get early access?</p>
                    <p className="grey-line">
                      Ask for an exclusive invite from existing user of
                      Dopamine.fit
                    </p>
                  </div>
                  <div className="social-icon-div">
                    {socialIcons.map((icon, i) => (
                      <IconButton
                        style={{ marginRight: 8 }}
                        key={i}
                        onClick={() => window.open(icon.link)}
                      >
                        <ImageLoader
                          src={icon.icon}
                          style={{ objectFit: "contain" }}
                        />
                      </IconButton>
                    ))}
                  </div>
                  <RWebShare
                    // data={{ text: "I'm in the queue for Dopamine's fitness banking revolution!🔥 Do you have the invite?", title: "Request an Invite", url: `https://dopamine.fit/?source=whatsapp&medium=web&user=${data?.user_id}` }}
                    data={{
                      text: "I'm waiting to join first ever AI powered community of fitness!🔥 Do you have the invite?",
                      title: "Request an Invite",
                      url: `https://dopamine.fit/`,
                    }}
                    onClick={() => {}}
                  >
                    <Button
                      id="step-8-request-invite"
                      style={{
                        marginTop: "1.6rem",
                        marginBottom: "1rem",
                        fontSize: "1em",
                        fontWeight: "bold",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        background:
                          "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",

                        color: " #FF4A01",
                      }}
                      fullWidth
                      variant="contained"
                      size="large"
                    >
                      Request an Invite
                    </Button>
                  </RWebShare>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="waitlist-top-section" style={{ height: "80%" }}>
            {
              // waitlistData?.admin_type_id === 1 &&
              <>
                <div className="logo-div">
                  <ImageLoader
                    src={
                      DOPELOGO
                      // waitlistData?.admin_type_id === 1
                      //   ? BUSINESSCARD
                      //   : waitlistData?.admin_type_id === 2
                      //   ? BUSINESSCARDBRAND
                      //   : BUSINESSCARDCENTRE
                    }
                    style={{
                      objectFit: "contain",
                      width: "176px",
                      height: "195px",
                      marginTop: 10,
                      // marginBottom: ismobile ? "-70px" : "-10px",

                      // // marginTop: "10%",
                      // height: "227px",
                    }}
                  />
                </div>
                <div
                  style={{
                    textAlign: "center",
                    marginTop: 20,
                    color: "#FFFFFF",
                    marginBottom: ismobile ? 0 : 50,
                  }}
                >
                  <p
                    className="white-line"
                    style={{
                      margin: 0,
                    }}
                  >
                    You’re on the waitlist
                  </p>
                  <p
                    className="queue-number"
                    style={{
                      color: "#FF4A01",
                      fontSize: 40,
                      fontWeight: 600,
                      margin: 0,
                    }}
                  >
                    {waitlistCount === 0 ? "--" : waitlistCount}
                  </p>
                  <p
                    className="grey-line"
                    style={{ margin: 0, color: "#C8C8C8", fontSize: 16 }}
                  >
                    Your position in queue
                  </p>
                </div>
              </>
            }
            {/* {waitlistData?.admin_type_id !== 1 && (
              <div className="polygon-div">
                <ImageLoader
                  src={CLOCK}
                  style={{
                    objectFit: "contain",
                    width: 100,
                    height: "auto",
                    margin: ismobile ? "40px 0 20px 0" : "50px 0 50px 0",
                  }}
                />
                <div style={{ textAlign: "center" }} className="text-div">
                  <p className="white-line">You’re on the waitlist</p>
                  <p className="queue-number">
                    {waitlistCount === 0 ? "--" : waitlistCount}
                  </p>
                  <p className="grey-line">Your position in queue</p>
                </div>
              </div>
            )} */}
          </div>

          <div
            style={{
              padding: ismobile ? "34px 25px 45px 25px" : "0px 25px 45px 25px",
            }}
          >
            <div
              style={{
                padding: "1px",
                background:
                  "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                borderRadius: "11.6279px",
              }}
            >
              <div
                className="waitlist-bottom-section"
                style={{
                  borderRadius: "11.6279px",
                  paddingTop: 0,

                  // paddingTop: data?.admin_type_id !== 1 && ismobile ? 160 : null,
                }}
              >
                <div className="early-access-div">
                  <div className="text-div">
                    <p className="white-line">Want to get early access?</p>
                    <p className="grey-line">
                      Ask for an exclusive invite from existing user of
                      Dopamine.fit
                    </p>
                  </div>
                  <div className="social-icon-div">
                    {socialIcons.map((icon, i) => (
                      <IconButton
                        style={{ marginRight: 8 }}
                        key={i}
                        onClick={() => window.open(icon.link)}
                      >
                        <ImageLoader
                          src={icon.icon}
                          style={{ objectFit: "contain" }}
                        />
                      </IconButton>
                    ))}
                  </div>
                  <RWebShare
                    // data={{ text: "I'm in the queue for Dopamine's fitness banking revolution!🔥 Do you have the invite?", title: "Request an Invite", url: `https://dopamine.fit/?source=whatsapp&medium=web&user=${data?.user_id}` }}
                    data={{
                      text: "I'm waiting to join first ever AI powered community of fitness!🔥 Do you have the invite?",
                      title: "Request an Invite",
                      url: `https://dopamine.fit/`,
                    }}
                    onClick={() => {}}
                  >
                    <Button
                      id="step-8-request-invite"
                      style={{
                        marginTop: "1.6rem",
                        marginBottom: "1rem",
                        fontSize: "1em",
                        fontWeight: "bold",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        background:
                          "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",

                        color: " #FF4A01",
                      }}
                      fullWidth
                      variant="contained"
                      size="large"
                    >
                      Request an Invite
                    </Button>
                  </RWebShare>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
